import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as DeveloperActions from 'app/developer-v3/Actions';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import {
  currentAppDefinitionEntity,
  currentDefinitionOverride,
} from 'app/developer-v3/selectors';
import {
  selectAppId,
  selectVersionNumber,
} from 'app/developer-v3/store/selectors';

import { Source } from './Source';

const mapStateToProps = state => {
  const integrationId = selectAppId(state);
  const isLoading =
    CliApp.selectors.all.isLoadingById(integrationId, state) ||
    CliAppDefinition.selectors.all.isLoadingById(integrationId, state);
  const appDefinitionEntity = currentAppDefinitionEntity(state);
  const isGUIIntegration =
    !isLoading &&
    CliAppDefinition.selectors.isGUIIntegration(appDefinitionEntity);
  const definitionOverride = currentDefinitionOverride(state);

  return {
    definitionString: JSON.stringify(definitionOverride, null, 2),
    integrationId,
    integrationVersion: selectVersionNumber(state),
    isGUIIntegration,
    isLoading,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  async onLoad() {
    const { id, version } = props.params;
    return dispatch(DeveloperActions.loadAppAndVersion(id, version));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(Source));
